<template>
  <span class="of-hidden d-flex align-center">
    <PhNote
      v-if="!noIcon"
      weight="fill"
      class="flex-grow-0 text-body-1 mr-2"
      :style="{ color: iconColor }"
    />
    <span class="d-block text-truncate">{{ $t('common.note') }}</span>
  </span>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { PhNote } from '@phosphor-icons/vue'
import { useNoteColors } from '@/utils/noteColors'

const props = defineProps({
  noIcon: Boolean,
  note: {
    type: Object,
    default: null,
  },
})

const { getNoteIconColor } = useNoteColors()

const iconColor = computed(() => {
  return getNoteIconColor(props.note?.color)
})
</script>
